
/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const { FuncTerm, NullTerm } = require('@cedalo/parser');

const JSG = require('../../JSG');
const Attribute = require('../attr/Attribute');
const StringAttribute = require('../attr/StringAttribute');
const FormatAttributes = require('../attr/FormatAttributes');
const Node = require('./Node');
const Expression = require('../expr/Expression');
const StringExpression = require('../expr/StringExpression');
const NumberExpression = require('../expr/NumberExpression');

module.exports = class SheetJsonNode extends Node {
	constructor() {
		super();

		this.addAttribute(new Attribute('json', new Expression('')));
	}

	newInstance() {
		return new SheetJsonNode();
	}

	getItemType() {
		return 'sheetjsonnode';
	}

	_assignName(id) {
		const name = this.getGraph().getUniqueName('Json');
		this.setName(name);
	}

	getSheet() {
		let sheet = this;

		while (sheet && !sheet.isStreamSheet) {
			sheet = sheet.getParent();
		}

		return sheet;
	}

	isMoveable() {
		if (this.getGraph().machineContainer.isRunning) {
			return false;
		}

		return super.isMoveable();
	}

	isAddLabelAllowed() {
		return false;
	}

	termToPropertiesCommands(sheet, term) {
		const cmp = super.termToPropertiesCommands(sheet, term);
		if (!cmp) {
			return undefined;
		}

		let json;
		const params = {useName: true, sheet, forceName: true};

		term.iterateParams((param, index) => {
			switch (index) {
				case 7: // json
					if (!(param instanceof NullTerm)) {
						json = new JSG.Expression(param.value, param.isStatic ? undefined : param.toString(params));
						json.evaluate(this);
					}
					break;
				default:
					break;
			}
		});

		if (json !== undefined) {
			cmp.add(new JSG.SetAttributeAtPathCommand(this, 'json', json));
		} else {
			cmp.add(new JSG.SetAttributeAtPathCommand(this, 'json', new JSG.Expression('')));
		}

		return cmp;
	}
};
